import { FormikContextType } from 'formik';
import { TDocFile, DocType } from 'shared/constants/docs';
import { prettyDate } from 'shared/utils/format';
import { FieldTextField } from 'shared/_ui/form/form-text-field';
import FileCloudIcon from 'shared/_model/project-files/FileCloudIcon';
import FilePlaylistIcon from 'shared/_model/project-files/FilePlaylistIcon';
import { Box } from '@mui/material';
import YoutubeFileIcon from 'shared/_model/publish/components/YoutubeFileIcon';
import { useSharingId } from 'shared/_model/sharing/utils';

type FileCardProps = {
	formik: FormikContextType<TDocFile>;
};

export default function FileCard({ formik }: FileCardProps) {
	const { sharingId } = useSharingId();

	const isFinishVideo = formik.values.type === DocType.FILE_FINISH_VIDEO;

	return (
		<Box>
			<FieldTextField
				label="Status:"
				value={
					<Box
						sx={{
							display: 'flex',
							gap: 1,
						}}
					>
						<FileCloudIcon cloud={formik.values.cloud} />
						{!sharingId && <FilePlaylistIcon fileId={formik.values._id} />}
						{isFinishVideo && <YoutubeFileIcon youtube={formik.values.youtube} />}
					</Box>
				}
				fullWidth
				labelProps={{ width: '4.75rem' }}
			/>
			<FieldTextField
				label="ID:"
				value={formik.values._id}
				fullWidth
				labelProps={{ width: '4.75rem' }}
			/>
			<FieldTextField
				label="Date:"
				value={prettyDate(formik.values.created)}
				fullWidth
				labelProps={{ width: '4.75rem' }}
			/>
			<FieldTextField
				label="Project ID:"
				value={formik.values.projectId}
				fullWidth
				labelProps={{ width: '4.75rem' }}
			/>
			<FieldTextField
				label="File name:"
				value={formik.values.filename}
				fullWidth
				labelProps={{ width: '4.75rem' }}
			/>
		</Box>
	);
}
